import { Link } from 'react-router-dom';
// import Logo from '../Assets/Images/company_logo.jpg';
import Logo from '../assets/images/logo-keystone';

import './header.scss';

import { useCurrentUser } from '../hooks/user-current-user.hook';

import { MenuComponent } from './menu.component';
import { LogoutComponent } from '../features/authentication/logout.component';
import { useEffect } from 'react';
import { useGetCompanyDetails } from '../apiclient/master/useGetCompanydetailsApi';
import { AvatarMenu } from '../features/authentication/avatar-menu';
import AppSidebar from './sidenavbar-menu';
import { SideNavbarTopMenuComponent } from './sidenavbar-top-menu';


export const SideBarHeaderComponent = ({ showMenu = true, disableLogoClick = false }: { showMenu?: boolean; disableLogoClick?: boolean }) => {
    const { fullName } = useCurrentUser();

    useEffect(() => {

    }, []);

    /* const { data: fetchedCompany } = useGetCompanyDetails(); */
    
    const getUnionName =()=>{
        const unionName = localStorage.getItem("AUTH_UNION");
        return  unionName!==undefined? unionName + " DCMPU" : "";
    }

    return (
        <div className="header">
            <nav
                   
                    className="navbar navbar-expand-sm navbar-toggleable-sm  bg-white border-bottom box-shadow">
               
                <div className="container-fluid d-flex" style={{backgroundColor:"#cce9ff"}} >
                    {!disableLogoClick ?
                        <Link to='/' className="navbar-brand d-flex justify-content-between align-items-center"/* className="navbar-brand" */>
                            <Logo />
                     </Link> :
                        <div className="navbar-brand" style={{ marginLeft: "-5px" }}>
                            <Logo />
                        </div>
                    }
                    <div className="menu-title"><h4>{getUnionName()}</h4></div>
                    <div className='ms-auto d-flex'>
                        <SideNavbarTopMenuComponent/>
                        {/* <AvatarDropdown/> */}
                    </div>
                </div>
            </nav>
        </div >
    );
};
